export enum CalendarFilterParam {
  PERSON_ID = 'pid',
  DATE = 'date',
}
